<template>
  <div data-notifications-handler />
</template>

<script lang="ts">
import { SET_BUBBLE_NOTIFICATIONS } from '@/map-phaser-new/constants'
import { useResponseTaskStore } from '@/store/pinia/responseTaskStore'
import { usePhaserGameIntegrationStore } from '@/store/pinia/map-new/phaserGameIntegrationStore'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { MECHANIC_GALLERY, MECHANIC_TOURNAMENTS } from '@/map-phaser-new/constants/common/mechanics'
import {
  GALLERY,
  TOURNAMENTS,
  ARENA,
  TRAINING_HALL,
} from '@/map-phaser-new/constants/common/buildings'

export default defineComponent({
  name: 'MapNotificationsHandler',
  computed: {
    ...mapState(useResponseTaskStore, {
      hasMechanic: 'hasMechanic',
      notifications: 'getNotifications',
    }),
    ...mapState(usePhaserGameIntegrationStore, { phaserEventEmitter: 'getPhaserEventEmitter' }),
  },
  watch: {
    'notifications.tournaments': {
      handler(): void {
        if (!this.hasMechanic(MECHANIC_TOURNAMENTS)) return
        this.phaserEventEmitter?.emit(SET_BUBBLE_NOTIFICATIONS, TOURNAMENTS)
      },
      deep: true,
    },
    'notifications.gallery_notifications': {
      handler(): void {
        if (!this.hasMechanic(MECHANIC_GALLERY)) return
        this.phaserEventEmitter?.emit(SET_BUBBLE_NOTIFICATIONS, GALLERY)
      },
      deep: true,
    },
    'notifications.arena_notifications': {
      handler(): void {
        this.phaserEventEmitter?.emit(SET_BUBBLE_NOTIFICATIONS, ARENA)
      },
      deep: true,
    },
    'notifications.training_hall_notifications': {
      handler(): void {
        this.phaserEventEmitter?.emit(SET_BUBBLE_NOTIFICATIONS, TRAINING_HALL)
      },
      deep: true,
    },
  },
})
</script>
